module.exports = {
  fr: {
    about: {
      label: "À propos",
      cgv: {
        label: "Conditions Générales de Vente",
        url: "/conditions-generales-de-vente/",
      },
      privacy: {
        label: "Mentions Légales",
        url: "/mentions-legales/",
      },
    },
    prestations: {
      label: "Prestations",
      wedding: {
        label: "Location voiture de Mariage",
        url: "/blog/location-voiture-de-mariage-avec-chauffeur",
      },
      bus: {
        label: "Location de bus",
        url: "/blog/location-bus-minibus-avec-chauffeur-prive",
      },
      business: {
        label: "Déplacements d'affaires",
        url: "/blog/deplacements-d-affaires",
      },
      event: {
        label: "Événementiel",
        url: "/blog/evenementiel",
      },
      aeroport: {
        label: "Transfert aéroport",
        url: "/blog/transfert-aeroport",
      },
      vtclyon: {
        label: "VTC Lyon",
        url: "/blog/vtc-lyon",
      },
      ski: {
        label: "Transfert ski",
        url: "/blog/transfert-ski",
      },
      visite: {
        label: "Visite guidée",
        url: "/blog/visite-guidee",
      },
    },
    partners: {
      label: "Organisations",
      atoutfrance: {
        label: "Atout France",
        url: "/blog/atout-france",
      },
      ffevtc: {
        label: "FFEVTC",
        url: "/blog/federation-francaise-des-exploitants-de-voiture-de-transport-avec-chauffeur",
      },
      onlylyon: {
        label: "ONLY LYON",
        url: "/blog/only-lyon",
      },
    },
    payment: {
      label: "Modes de paiement",
      visa: {
        label: "Visa",
        url: "https://www.visa.fr/",
      },
      mastercard: {
        label: "Master Card",
        url: "https://www.mastercard.fr/fr-fr.html",
      },
      amex: {
        label: "American Express",
        url: "https://www.americanexpress.com/fr/",
      },
      paypal: {
        label: "Paypal",
        url: "https://www.paypal.com/fr/home",
      },
      applepay: {
        label: "Apple Pay",
        url: "https://www.apple.com/fr/apple-pay/",
      },
      cash: {
        label: "Chèques et Espèces",
      },
    },
    translation: {
      label: "Traduction",
    },
    social: {
      label: "Réseaux Sociaux",
      facebook: {
        label: "Facebook",
        url: "https://www.facebook.com/davoyage.chauffeur.prive",
      },
      twitter: {
        label: "Twitter",
        url: "https://twitter.com/davoyage_vtc",
      },
      instagram: {
        label: "Instagram",
        url: "https://www.instagram.com/davoyage/",
      },
      linkedin: {
        label: "Linkedin",
        url: "https://www.linkedin.com/company/davoyage-chauffeur-privé/",
      },
    },
  },
  en: {
    about: {
      label: "About",
      cgv: {
        label: "Commercial Terms",
        url: "/en/conditions-generales-de-vente/",
      },
      privacy: {
        label: "Legal Notice",
        url: "/en/mentions-legales/",
      },
    },
    prestations: {
      label: "Offers",
      wedding: {
        label: "Wedding",
        url: "/en/blog/wedding-car-rental-with-driver",
      },
      bus: {
        label: "Bus rental",
        url: "/en/blog/bus-rental",
      },
      business: {
        label: "Business trips",
        url: "/en/blog/business-trips",
      },
      event: {
        label: "Events",
        url: "/en/blog/events",
      },
      aeroport: {
        label: "Airport transfer",
        url: "/en/blog/airport-transfer",
      },
      vtclyon: {
        label: "VTC Lyon",
        url: "/en/blog/chauffeured-car-rental-in-lyon",
      },
      ski: {
        label: "Ski transfer",
        url: "/en/blog/ski-transfer",
      },
      visite: {
        label: "Guided tour",
        url: "/en/blog/guided-tour",
      },
    },
    partners: {
      label: "Organizations",
      atoutfrance: {
        label: "Atout France",
        url: "/en/blog/atout-france",
      },
      ffevtc: {
        label: "FFEVTC",
        url: "/en/blog/discover-the-french-federation-of-private-passenger-transport-companies-ffevtc",
      },
      onlylyon: {
        label: "ONLY LYON",
        url: "/en/blog/only-lyon",
      },
    },
    payment: {
      label: "Payment method",
      visa: {
        label: "Visa",
        url: "https://www.visa.com/",
      },
      mastercard: {
        label: "Master Card",
        url: "https://www.mastercard.fr/fr-fr.html",
      },
      amex: {
        label: "American Express",
        url: "https://www.americanexpress.com/fr/",
      },
      paypal: {
        label: "Paypal",
        url: "https://www.paypal.com/fr/home",
      },
      applepay: {
        label: "Apple Pay",
        url: "https://www.apple.com/fr/apple-pay/",
      },
      cash: {
        label: "Chèques et Espèces",
      },
    },
    translation: {
      label: "Translation",
    },
    social: {
      label: "Social Networks",
      facebook: {
        label: "Facebook",
        url: "https://www.facebook.com/davoyage.chauffeur.prive",
      },
      twitter: {
        label: "Twitter",
        url: "https://twitter.com/davoyage_vtc",
      },
      instagram: {
        label: "Instagram",
        url: "https://www.instagram.com/davoyage/",
      },
      linkedin: {
        label: "Linkedin",
        url: "https://www.linkedin.com/company/davoyage-chauffeur-privé/",
      },
    },
  },
  ru: {
    about: {
      label: "кстати",
      cgv: {
        label: "Общие условия продажи",
        url: "/ru/conditions-generales-de-vente/",
      },
      privacy: {
        label: "Юридические вопросы",
        url: "/ru/mentions-legales/",
      },
    },
    prestations: {
      label: "черты",
      wedding: {
        label: "брак",
        url: "/ru/blog/Прокат-свадебных-автомобилей-с-водителем",
      },
      bus: {
        label: "Прокат автобусов",
        url: "/ru/blog/Прокат-автобусов",
      },
      business: {
        label: "Деловые поездки",
        url: "/ru/blog/Деловые-поездки",
      },
      event: {
        label: "события",
        url: "/ru/blog/события",
      },
      aeroport: {
        label: "Трансфер из аэропорта",
        url: "/ru/blog/Трансфер-из-аэропорта",
      },
      vtclyon: {
        label: "VTC Lyon",
        url: "/ru/blog/vtc-lyon",
      },
      ski: {
        label: "Лыжный трансфер",
        url: "/ru/blog/Лыжный-трансфер",
      },
      visite: {
        label: "Экскурсия",
        url: "/ru/blog/Экскурсия",
      },
    },
    partners: {
      label: "Организации",
      atoutfrance: {
        label: "Atout France",
        url: "/ru/blog/atout-france",
      },
      ffevtc: {
        label: "FFEVTC",
        url: "/ru/blog/frantsuzskaya-federatsiya-perevozchikov-naemnykh-transportnykh-sredstv-ffevtc",
      },
      onlylyon: {
        label: "ONLY LYON",
        url: "/ru/blog/only-lyon",
      },
    },
    payment: {
      label: "Способ оплаты",
      visa: {
        label: "Visa",
        url: "https://www.visa.com.ru/",
      },
      mastercard: {
        label: "Master Card",
        url: "https://www.mastercard.fr/fr-fr.html",
      },
      amex: {
        label: "American Express",
        url: "https://www.americanexpress.com/fr/",
      },
      paypal: {
        label: "Paypal",
        url: "https://www.paypal.com/fr/home",
      },
      applepay: {
        label: "Apple Pay",
        url: "https://www.apple.com/fr/apple-pay/",
      },
      cash: {
        label: "Чеки и наличные деньги",
      },
    },
    translation: {
      label: "перевод",
    },
    social: {
      label: "Социальные сети",
      facebook: {
        label: "Facebook",
        url: "https://www.facebook.com/davoyage.chauffeur.prive",
      },
      twitter: {
        label: "Twitter",
        url: "https://twitter.com/davoyage_vtc",
      },
      instagram: {
        label: "Instagram",
        url: "https://www.instagram.com/davoyage/",
      },
      linkedin: {
        label: "Linkedin",
        url: "https://www.linkedin.com/company/davoyage-chauffeur-privé",
      },
    },
  },
  de: {
    about: {
      label: "Über uns",
      cgv: {
        label: "AGB",
        url: "/de/conditions-generales-de-vente/"
      },
      privacy: {
        label: "Impressum",
        url: "/de/mentions-legales/"
      }
    },
    prestations: {
      label: "Leistungen",
      wedding: {
        label: "Hochzeit",
        url: "/de/blog/hochzeitsauto-mit-chauffeur-lyon"
      },
      bus: {
        label: "Busvermietung",
        url: "/de/blog/bus-und-minibus-mit-fahrer-lyon"
      },
      business: {
        label: "Geschäftsreisen",
        url: "/de/blog/geschaeftsreisen-mit-chauffeur-lyon"
      },
      event: {
        label: "Veranstaltungen",
        url: "/de/blog/eventtransport-lyon"
      },
      aeroport: {
        label: "Flughafentransfer",
        url: "/de/blog/flughafentransfer-lyon-saint-exupery"
      },
      vtclyon: {
        label: "Chauffeurservice Lyon",
        url: "/de/blog/privatchauffeur-lyon"
      },
      ski: {
        label: "Skitransfer",
        url: "/de/blog/skitransfer-ab-lyon"
      },
      visite: {
        label: "Geführte Tour",
        url: "/de/blog/stadtfuehrung-lyon-mit-privatchauffeur"
      }
    },
    partners: {
      label: "Organisationen",
      atoutfrance: {
        label: "Atout France",
        url: "/de/blog/atout-france"
      },
      ffevtc: {
        label: "FFEVTC",
        url: "/de/blog/franzoesischer-verband-evtc-ffevtc"
      },
      onlylyon: {
        label: "ONLY LYON",
        url: "/de/blog/only-lyon"
      }
    },
    payment: {
      label: "Zahlungsmittel",
      visa: {
        label: "Visa",
        url: "https://www.visa.com/"
      },
      mastercard: {
        label: "Master Card",
        url: "https://www.mastercard.fr/fr-fr.html"
      },
      amex: {
        label: "American Express",
        url: "https://www.americanexpress.com/fr/"
      },
      paypal: {
        label: "Paypal",
        url: "https://www.paypal.com/fr/home"
      },
      applepay: {
        label: "Apple Pay",
        url: "https://www.apple.com/fr/apple-pay/"
      },
      cash: {
        label: "Schecks und Bargeld"
      }
    },
    translation: {
      label: "Übersetzung"
    },
    social: {
      label: "Soziale Netzwerke",
      facebook: {
        label: "Facebook",
        url: "https://www.facebook.com/davoyage.chauffeur.prive"
      },
      twitter: {
        label: "Twitter",
        url: "https://twitter.com/davoyage_vtc"
      },
      instagram: {
        label: "Instagram",
        url: "https://www.instagram.com/davoyage/"
      },
      linkedin: {
        label: "Linkedin",
        url: "https://www.linkedin.com/company/davoyage-chauffeur-privé/"
      }
    }
  },
  it: {
    about: {
      label: "Chi siamo",
      cgv: {
        label: "Condizioni generali di vendita",
        url: "/it/conditions-generales-de-vente/"
      },
      privacy: {
        label: "Note legali",
        url: "/it/mentions-legales/"
      }
    },
    prestations: {
      label: "Servizi",
      wedding: {
        label: "Matrimoni",
        url: "/it/blog/auto-per-matrimonio-con-autista-lione"
      },
      bus: {
        label: "Noleggio autobus",
        url: "/it/blog/noleggio-bus-e-minibus-con-autista-lione"
      },
      business: {
        label: "Viaggi d'affari",
        url: "/it/blog/viaggi-di-lavoro-con-autista-lione"
      },
      event: {
        label: "Eventi",
        url: "/it/blog/trasporto-eventi-lione"
      },
      aeroport: {
        label: "Transfer aeroportuale",
        url: "/it/blog/transfer-aeroporto-lione-saint-exupery"
      },
      vtclyon: {
        label: "NCC Lione",
        url: "/it/blog/autista-privato-lione"
      },
      ski: {
        label: "Transfer sci",
        url: "/it/blog/transfer-sci-da-lione"
      },
      visite: {
        label: "Visita guidata",
        url: "/it/blog/visita-guidata-lione-con-autista-privato"
      }
    },
    partners: {
      label: "Organizzazioni",
      atoutfrance: {
        label: "Atout France",
        url: "/it/blog/atout-france"
      },
      ffevtc: {
        label: "FFEVTC",
        url: "/it/blog/federazione-francese-ncc-ffevtc"
      },
      onlylyon: {
        label: "ONLY LYON",
        url: "/it/blog/only-lyon"
      }
    },
    payment: {
      label: "Metodi di pagamento",
      visa: {
        label: "Visa",
        url: "https://www.visa.com/"
      },
      mastercard: {
        label: "Master Card",
        url: "https://www.mastercard.fr/fr-fr.html"
      },
      amex: {
        label: "American Express",
        url: "https://www.americanexpress.com/fr/"
      },
      paypal: {
        label: "Paypal",
        url: "https://www.paypal.com/fr/home"
      },
      applepay: {
        label: "Apple Pay",
        url: "https://www.apple.com/fr/apple-pay/"
      },
      cash: {
        label: "Assegni e contanti"
      }
    },
    translation: {
      label: "Traduzione"
    },
    social: {
      label: "Social network",
      facebook: {
        label: "Facebook",
        url: "https://www.facebook.com/davoyage.chauffeur.prive"
      },
      twitter: {
        label: "Twitter",
        url: "https://twitter.com/davoyage_vtc"
      },
      instagram: {
        label: "Instagram",
        url: "https://www.instagram.com/davoyage/"
      },
      linkedin: {
        label: "Linkedin",
        url: "https://www.linkedin.com/company/davoyage-chauffeur-privé/"
      }
    }
  },
  es: {
    about: {
      label: "Sobre nosotros",
      cgv: {
        label: "Condiciones generales de venta",
        url: "/es/conditions-generales-de-vente/"
      },
      privacy: {
        label: "Aviso legal",
        url: "/es/mentions-legales/"
      }
    },
    prestations: {
      label: "Servicios",
      wedding: {
        label: "Bodas",
        url: "/es/blog/coche-de-boda-con-chofer-lyon"
      },
      bus: {
        label: "Alquiler de autobuses",
        url: "/es/blog/alquiler-autobus-y-minibus-con-conductor-lyon"
      },
      business: {
        label: "Viajes de negocios",
        url: "/es/blog/viajes-de-negocios-con-chofer-lyon"
      },
      event: {
        label: "Eventos",
        url: "/es/blog/transporte-para-eventos-lyon"
      },
      aeroport: {
        label: "Traslado al aeropuerto",
        url: "/es/blog/traslado-aeropuerto-lyon-saint-exupery"
      },
      vtclyon: {
        label: "VTC Lyon",
        url: "/es/blog/chofer-privado-lyon"
      },
      ski: {
        label: "Traslado de esquí",
        url: "/es/blog/traslados-a-estaciones-de-esqui-desde-lyon"
      },
      visite: {
        label: "Visita guiada",
        url: "/es/blog/visita-guiada-lyon-con-chofer-privado"
      }
    },
    partners: {
      label: "Organizaciones",
      atoutfrance: {
        label: "Atout France",
        url: "/es/blog/atout-france"
      },
      ffevtc: {
        label: "FFEVTC",
        url: "/es/blog/federacion-francesa-vtc-ffevtc"
      },
      onlylyon: {
        label: "ONLY LYON",
        url: "/es/blog/only-lyon"
      }
    },
    payment: {
      label: "Medios de pago",
      visa: {
        label: "Visa",
        url: "https://www.visa.com/"
      },
      mastercard: {
        label: "Master Card",
        url: "https://www.mastercard.fr/fr-fr.html"
      },
      amex: {
        label: "American Express",
        url: "https://www.americanexpress.com/fr/"
      },
      paypal: {
        label: "Paypal",
        url: "https://www.paypal.com/fr/home"
      },
      applepay: {
        label: "Apple Pay",
        url: "https://www.apple.com/fr/apple-pay/"
      },
      cash: {
        label: "Cheques y efectivo"
      }
    },
    translation: {
      label: "Traducción"
    },
    social: {
      label: "Redes sociales",
      facebook: {
        label: "Facebook",
        url: "https://www.facebook.com/davoyage.chauffeur.prive"
      },
      twitter: {
        label: "Twitter",
        url: "https://twitter.com/davoyage_vtc"
      },
      instagram: {
        label: "Instagram",
        url: "https://www.instagram.com/davoyage/"
      },
      linkedin: {
        label: "Linkedin",
        url: "https://www.linkedin.com/company/davoyage-chauffeur-privé/"
      }
    }
  }
};
